import LocalizedStrings from "@/LocalizedStrings";

export let cultureService : CultureService= null!;
export let ls : LocalizedStrings = null!;

export interface CultureOptions {
    changeCultureToEstonianUrl : string,
    changeCultureToEnglishUrl : string,
    currentCulture : string,
    localizedStrings : LocalizedStrings
}

export enum Culture {
    Estonian =  "et-EE",
    English = "en-GB"
}

export class CultureService {
    constructor(private readonly options : CultureOptions) {
    }
    
    static initialize(options : CultureOptions) : void
    {
        cultureService = new CultureService(options)
        ls = options.localizedStrings;
    }
    
    get currentCulture() : Culture {
        switch (this.options.currentCulture) {
            case "en-GB":
                return Culture.English;
            case "et-EE":
            default:
                return Culture.Estonian;
        }
    }

    get currentCulture2Letter() : string {
        return this.currentCulture.split('-')[0];
    }
    
    async changeToEstonian() {
            await fetch(this.options.changeCultureToEstonianUrl, {
                method: 'POST',
            }).then(response => window.location.reload());
    }

    async changeToEnglish() {
        await fetch(this.options.changeCultureToEnglishUrl, {
            method: 'POST',
        }).then(response => window.location.reload());
    }
}